
import { Component, Prop, Vue } from 'vue-property-decorator'

import BacModal from '@/components/BacModal.vue'
import BacInput from '@/components/BacInput.vue'
import BacButton from '@/components/BacButton.vue'

import { Http } from '@/lib/utils/Http'
import { CustomerRegister } from '../../../lib/models/CustomerRegister'
import UIkit from 'uikit'

@Component({
  components: {
    BacModal,
    BacInput,
    BacButton
  }
})
export default class EditCustomerRegisterModal extends Vue {
    @Prop({ default: () => new CustomerRegister() }) customerRegister!: CustomerRegister

    CustomerRegister = CustomerRegister // for use in template

    async save () {
      const res = await Http.request(`/api/customer-register/${this.customerRegister.id}`, {
        method: 'put',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.customerRegister)
      })
      if (res.status === 200) {
        UIkit.notification({
          message: 'Registrierung gespeichert!',
          status: 'success',
          timeout: 5000,
          pos: 'bottom-center'
        })
        UIkit.modal('#edit-register-modal').hide()
      } else {
        UIkit.notification({
          message: 'Es ist ein unbekannter Fehler aufgetreten, bite wende dich an den Entwickler!',
          status: 'success',
          timeout: 5000,
          pos: 'bottom-center'
        })
      }
    }
}

